import axios from 'axios';

export async function fetchActiveArenaMatchId(username) {
  if (!username) return '';
  const res = await axios.get(`/api/arena/online/status?username=${encodeURIComponent(username)}`);
  if (res.data?.success && res.data.status === 'matched' && res.data.matchId) {
    return res.data.matchId;
  }
  return '';
}
